var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsDown = function SvgThumbsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.85 3.04a1.201 1.201 0 0 0-.803-.29H16.5V11h1.547a1.2 1.2 0 0 0 1.203-.987V3.737a1.2 1.2 0 0 0-.4-.698Zm-4.183 8.682-3.308 7.441a1.833 1.833 0 0 1-1.276-1.746V13.75a.917.917 0 0 0-.916-.917H3.968a.917.917 0 0 1-.917-1.053l1.265-8.25a.917.917 0 0 1 .917-.78h9.434v8.972ZM18.023.917a3.034 3.034 0 0 1 3.052 2.627c.006.04.008.082.008.123v6.416a.92.92 0 0 1-.008.123 3.035 3.035 0 0 1-3.052 2.627H16.18l-3.425 7.706a.917.917 0 0 1-.837.544 3.666 3.666 0 0 1-3.667-3.666v-2.75H3.983a2.749 2.749 0 0 1-2.744-3.163l1.265-8.25A2.752 2.752 0 0 1 5.248.917h12.775Z",
    clipRule: "evenodd"
  })));
};
export default SvgThumbsDown;